export enum MicrosoftFormFAQsItem {
  AUTHORIZATION_DETAIL = 'authorization-detail',
  RESALE_INFO = 'resale-info',
  CONTRACT_DURATION = 'contract-duration',
  RENEWAL = 'renewal',
  PRICING = 'pricing',
  META_DATA = 'meta-data',
  BUYER_NOTIFICATION = 'buyer-notification',
  PURCHASE_TERMS = 'purchase-terms',
  STAKEHOLDERS = 'stakeholders',
  EULA = 'eula',
}
